import styles from './UserInfo.module.scss'
import profile from 'assets/logo_mini2.png'
import classnames from 'classnames'
import { Icon } from 'components/Icon/Icon'

export type UserInfoType = {
    file?: any,
    name: string,
    link: string,
    about: string,
    twitter?: string | null,
    instagram?: string | null,
    facebook?: string | null,
    patrons: string,
    drizzles: string,
    defaultColor?: string,
    votes?: string
    position?: number
}

type Props = {
    data: UserInfoType,
    isPublic?: boolean,
}

export function UserInfo(props: Props) {

    const networksClassName = classnames({
        [styles['networks']]: true,
        [styles['networks_disabled']]: !props.isPublic
    })

    console.log(props.data.position)

    return (
        <div className={styles['container']}>
            <div className={styles['wrapper']}>
                <div className={styles['imgWrapp']}>
                    {props.data.position && (
                        <div className={styles['star']}>
                            <Icon name='star_bg' />
                            <div className={styles['position']}>
                                #{props.data.position}
                            </div>
                        </div>)}
                    <img src={profile} className={styles['img']} alt='logo_mini2' />
                </div>
                <div className={styles['info']}>
                    <div>
                        <div className={styles['info__name']}>
                            {props.data.name}
                        </div>
                        <div className={styles['info__analytic']}>
                            <span><b>{props.data.patrons}</b> patrons</span>
                            <span><b>${props.data.drizzles}</b> drizzles</span>
                            {/* <span>{props.data.votes} votes</span> */}
                        </div>
                    </div>
                    <div className={styles['description']}>
                        {props.isPublic ? props.data.about : <Icon name='skeleton' />}
                    </div>
                    <div className={networksClassName}>
                        {/* <div className={styles['network']} onClick={() => { }}>
                            <Icon name='facebook' />
                        </div> */}
                        <div className={styles['network']} onClick={() => { }}>
                            <Icon name='instagram' />
                        </div>
                        <div className={styles['network']} onClick={() => { }}>
                            <Icon name='twitter' />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

UserInfo.defaultProps = {
    isPublic: true,
}



